import React from "react";
import { Dropdown, Option, useId, makeStyles, Tooltip } from "@fluentui/react-components";
import { FluentField } from "../FluentUI/Fluent-Field";
import PropTypes from 'prop-types';
import "../FluentUI/fluent-overide.scss";

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    fontWeight: 600,
    textAlign: "left",
    width: "100%",
    color: "#4E4E4E",
    "& button:disabled": {
      backgroundColor: "#f3f2f1",
      color: "#242424",
    },
  },
  tooltipContainer: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    cursor: "pointer",
  },
});

const DropdownProjectOwner = ({
  label,
  disabled,
  validationMessage,
  required,
  size,
  placeholder,
  options,
  onChange,
  componentStyle,
  selectedOptions,
  value,
  multiselect = true,
  multiSelectMessage = "{count} Members Selected",
}) => {
  
  const dropdownId = useId("dropdown-default");
  const fieldStyle = useStyles();
  if (!multiselect) return null; // Not rendered in single-owner mode 
  const combinedStyles = componentStyle || fieldStyle.root;

  const renderOption = (option) => {
    if (typeof option === "object" && option !== null) {
      return (
        <Option key={option.key} value={option.value} text={option.text}>
          {option.text}
        </Option>
      );
    }
    return (
      <Option key={option} value={option} text={option}>
        {option}
      </Option>
    );
  };

  const safeSelectedOptions = Array.isArray(selectedOptions) ? selectedOptions : [];
  const selectedItems = options.filter(opt => safeSelectedOptions.includes(opt.value));  
  const tooltipContent = selectedItems.map(opt => opt.text).join(", ");
  let displayValue = selectedItems.length > 3
    ? multiSelectMessage.replace("{count}", selectedItems.length)
    : selectedItems.map(opt => opt.text).join(", ");

  return (
    <FluentField label={label} size={size} validationMessage={validationMessage} required={required}>
      <Tooltip content={tooltipContent || "No members selected"} relationship="label">
        <Dropdown
          aria-labelledby={dropdownId}
          placeholder={placeholder}
          onOptionSelect={(e, data) => {
            const selectedOwners = data?.selectedOptions.map(option => {
              const [idStr, isGroupStr] = option.split("-");
              return {
                Id: parseInt(idStr, 10),
                IsGroup: isGroupStr === "true"
              };
            });
            onChange(e, { selectedOwners });
          }}
          value={displayValue}
          disabled={disabled}
          className={combinedStyles}
          selectedOptions={selectedOptions}
          multiselect={multiselect}
        >
          {options.map((option) => renderOption(option))}
        </Dropdown>
      </Tooltip>
    </FluentField>
  );
};

export default DropdownProjectOwner;

DropdownProjectOwner.propTypes = {
  label: PropTypes.string,
  disabled: PropTypes.bool,
  validationMessage: PropTypes.string,
  required: PropTypes.bool,
  placeholder: PropTypes.string,
  options: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  componentStyle: PropTypes.string,
  size: PropTypes.string,
  selectedOptions: PropTypes.array,
  value: PropTypes.string,
  multiselect: PropTypes.bool,
  multiSelectMessage: PropTypes.string,
};